import React, {useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import {Button} from '../Button/index.js';
import {Card} from '../Card/index.js';
import {Text} from '../Text/index.js';
import "./index.css";


export default (props) => {
  
  const ref = useRef();
  
  const [isOpen, setOpen] = useState(false);
  const [pos, setPos] = useState({});
  
  function open() {
    const rect = ref.current.getBoundingClientRect();
    setPos({
      top: rect.top + rect.height,
      left: rect.left
    });
    setOpen(true);
  }
  
  function close() {
    setOpen(false);
  }
  
  function select(option) {
    props.onChange(option);
    close();
  }
  
  const selectedOption = props.options.find(o => o.value === props.value);
  
  const menu = !isOpen ? null : ReactDOM.createPortal(
    <div key="menu" className="select-overlay" onClick={close}>
      <Card style={{...pos}} className="select-card">
        {props.options.map(option => 
          <Button
            block
            key={option.key || option.value}
            label={option.label}
            onClick={() => select(option.value)}
          />
        )}
      </Card>
    </div>, 
    document.body
  );
  
  const value = selectedOption ? selectedOption.label : 
                props.value ? props.value :
                props.placeholder ? props.placeholder :
                "";
  
  const input = (
    <div 
      ref={ref} 
      key="input" 
      className={`select-input ${props.large ? 'large' : ''}`} 
      onClick={open} 
      style={props.style}>
      
      <Text>{value}</Text>
      <svg height="6px" viewBox="0 0 9.94 7.56" className="select-caret">
        <polyline fill="#aaaaaa" points="9.94,0 4.97,7.56 0,0 "/>
      </svg>
      
    </div>
  );
  
  return [input, menu];
};
